<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="backIndex">Back to index</ion-button>
          <ion-button class="btn-back" @click="prev" v-if="index.prev"><span class="prev"></span></ion-button>
          <ion-button class="btn-back" @click="next" v-if="index.next"><span class="next"></span></ion-button>
          <ion-button class="btn-back" @click="backReport">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-grid>
        <form @submit="save">
          <ion-row class="row-boxed mt-20">
            <ion-col size="12">
              <div class="title">{{ index.title }}</div>
            </ion-col>
            <ion-col size="12">
              <div class="text-left" v-if="$store.state.user_role == 'client'" v-html="index.value"></div>
              <editor
                v-if="$store.state.user_role != 'client'"
                api-key="ziquynqyvxghn486hafy54gua465ydorsc91xvt7tut1laj4"
                v-model="index.value"
                :init="{
                  height: 500,
                  menubar: false,
                  plugins: [
                    'advlist autolink lists link image charmap',
                    'searchreplace visualblocks code fullscreen',
                    'print preview anchor insertdatetime media',
                    'paste code help wordcount table'
                  ],
                  toolbar:
                    'undo redo | alignleft aligncenter alignright | bullist numlist | table | bold italic forecolor fontsizeselect | code'
                }"
              >
              </editor>
            </ion-col>
          </ion-row>
          <ion-row class="row-boxed mt-20">
            <ion-col size="12">
              <div class="item-block">
                <div class="item-block-header">
                  <div>PHOTOS</div>
                      <file-upload
                          v-if="$store.state.user_role != 'client'"
                          input-id="uploadImg"
                          class="upload-btn"
                          :post-action="apiUrl + '/api/v1/upload'"
                          :data="{api_token: $store.state.api_token}"
                          :multiple="true"
                          :drop="true"
                          :extensions="['jpg', 'jpeg', 'gif', 'png', 'webp']"
                          :drop-directory="false"
                          v-model="images"
                          @input-file="inputYatchImg"
                          ref="uploadImg">
                        <img src="../assets/svg/icon-add.svg">
                      </file-upload>
                </div>
                <div class="item-block-content item-block-content-full">
                  <div class="img-wrapper">
                    <div v-for="(ic,i) in index.images" :key="'im'+i" class="index-img">
                      <span v-if="$store.state.user_role != 'client'" @click="() => removeItemImage(i)">-</span>
                      <img :src="ic">
                    </div>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="row-boxed" v-if="$store.state.user_role != 'client'">
            <ion-col size="12" class="text-right">
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>

          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
import Editor from '@tinymce/tinymce-vue'
import FileUpload from "vue-upload-component";
export default {
  name: "CompileIndexText",
  components: {
    editor: Editor,
    FileUpload
  },
  data: function() {
    return {
      index: { value: '', images: [] },
      loader: true,
      images: []
    }
  },
  methods: {
    backIndex: async function(){
      await this.save(null)
      this.$router.push('/report/details/'+this.index.report_id);
    },
    prev: function() {
      this.$router.push({name: 'compile-' + (this.index.prev.type == 'tt' ? 'text' : 'index'), params: { id: this.index.prev.id } });
      this.getIndex()
    },
    next: function() {
      this.$router.push({name: 'compile-' + (this.index.next.type == 'tt' ? 'text' : 'index'), params: { id: this.index.next.id } });
      this.getIndex()
    },
    backReport: async function() {
      await this.save(null)
      if(this.index.yacht_id) {
        this.$router.push('/report/'+this.index.yacht_id);
      } else {
        this.$router.push('/report/details/'+this.index.report_id);
        // this.$router.back();
      }
    },
    save: async function(ev) {
      if(ev) {
        ev.preventDefault();
      }
      this.loader = true
      await axios.post(this.apiUrl + '/api/v1/save-index', { api_token: this.$store.state.api_token, index: this.index })
      .then(() => {
        this.loader = false;
      }).catch(async () => {
        this.loader = false
        const toast = await this.$ionic.toastController.create({
          message: 'Generic error. Try to save again.',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      })
    },
    getIndex: function() {
      axios.post(this.apiUrl + '/api/v1/get-index', { api_token: this.$store.state.api_token, id: this.$route.params.id })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.index = res.data
          if(this.index.images == null || this.index.images === '') {
            Vue.set(this.index, 'images', [])
          }
        }
        this.loader = false;
      }).catch(async () => {
        this.loader = false
        const toast = await this.$ionic.toastController.create({
          message: 'Generic error. We\'re trying to reload the page.',
          color: 'danger',
          position: 'bottom',
          duration: 3000
        })
        await toast.present();

        setTimeout(() => {
          window.location.reload()
        }, 3000)
      })
    },
    async inputYatchImg(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.loader = true;
        }
        if (newFile.error && !oldFile.error) {
          if (newFile.error && newFile.error == 'extension') {
            const toast = await this.$ionic.toastController.create({
              message: 'File not supported',
              color: 'danger',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
        }
        if (newFile.success && !oldFile.success) {
          this.loader = false;
          this.index.images.push(newFile.response.file)
          const toast = await this.$ionic.toastController.create({
            message: 'Image added succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadImg.active) {
          this.$refs.uploadImg.active = true
        }
      }
    },
    removeItemImage: function(index) {
      this.index.images.splice(index, 1);
    },
  },
  mounted: function() {
    this.getIndex()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index-img {
  position: relative;
  border: 1px solid;
  font-size: 0;
  margin-bottom: 25px;
  padding: 10px;
}

.index-img span {
  position: absolute;
  font-size: 16px;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-color: var(--ion-color-primary);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

.img-wrapper {
  text-align: center;
}

</style>